import { Command } from './types';

export const commandCreator =
  <T>(type: string): ((payload: T) => Command<T>) =>
  payload => ({
    type,
    payload,
  });
